import { css } from "@emotion/react";
import { BaseButtonProps, Button } from "../Button";

export interface PaginationItemProps
  extends
    BaseButtonProps,
    Omit<React.ComponentPropsWithoutRef<"button">, "color"> {
  current?: boolean;
}

export const PaginationItem = ({
  current,
  children,
  ...props
}: PaginationItemProps) => {
  const buttonProps = current
    ? ({
        variant: "filled",
        color: "primary",
      } as const)
    : {};
  return (
    <Button
      css={css`
        text-decoration: none;
        transition: none;
      `}
      icon={children}
      {...buttonProps}
      {...props}
    />
  );
};
